module.exports = __webpack_public_path__ + "static/img/b-flash.0b5b4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/b-flash.png
// module id = Uoyk
// module chunks = 31